const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">


      {/* Hero Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Your privacy is important to us. This policy explains how we collect, use, and protect your information.
          </p>
          <p className="text-sm text-gray-500 mt-4">Last updated: 9 June, 2025</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. What We Collect</h2>
              <p className="text-gray-600 mb-4">When you interact with our website, we may collect the following information:<br/>> Your name<br/>> Contact details<br/>> Shipping address<br/>> Images and design inputs shared for custom orders</p>
            </div>
<hr/>
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mt-5 mb-4">2. How We Use Your Information</h2>
              <p className="text-gray-600 mb-4">We use your information for the following purposes:<br/>> To create and deliver personalized resin products<br/>> To communicate regarding orders, customizations, and delivery<br/>> To improve our platform and services<br/>> For internal record-keeping and customer support.</p>
            </div>
<hr/>
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mt-5 mb-4">3. Data Security & Confidentiality</h2>
              <p className="text-gray-600 mb-4">
                We do not share your data with third parties.<br/>All your chats, images, and customization details are kept confidential.<br/>Your data is only used for the purpose of completing your order and enhancing user experience.
</p>
            </div>
<hr/>
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mt-5 mb-4">4. Your Consent</h2>
              <p className="text-gray-600 mb-4">By using our website and services, you consent to the collection and use of your information as outlined in this Privacy Policy.<br/>If you have any questions or concerns, please contact us directly at our support email or whatsapp.</p>
            </div>
<hr/>


            
            <div className="mb-12 mt-4">
              <div className="bg-gray-50 rounded-lg p-6">
             <h2 className="text-2xl font-bold text-gray-900 mt-4 mb-4">Thank you for trusting RangDesaaj – Crafted with Resin, Customized with Love.</h2>
              </div>
            </div>
          </div>
        </div>
      </section>


    </div>
  )
}

export default PrivacyPolicy
